import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=f5d268be&scoped=true"
import script from "./trade.vue?vue&type=script&lang=js"
export * from "./trade.vue?vue&type=script&lang=js"
import style0 from "./trade.vue?vue&type=style&index=0&id=f5d268be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d268be",
  null
  
)

export default component.exports